// Настройка Turbo под особенности этого сайта.

import { installLoading } from "./loading.js";

/**
 * Если фрейм ответил страницей без нужного id (типично при редиректе на вход
 * по истечении сессии), Turbo бросает ошибку. Уходим на полную навигацию.
 */
function handleMissingFrame() {
  document.addEventListener("turbo:frame-missing", (event) => {
    const { response, visit } = event.detail;
    event.preventDefault();
    visit(response.url);
  });
}

/**
 * Ссылки, которые Turbo перехватывать не должен: чужой JS в админке
 * и скачивание файла.
 */
function markExternalLinks() {
  const selectors = ['a[href^="/admin"]', 'a[href$=".apk"]', 'a[download]'];
  document.addEventListener("turbo:load", () => {
    document.querySelectorAll(selectors.join(",")).forEach((link) => {
      link.setAttribute("data-turbo", "false");
    });
  });
}

/**
 * Всё, что дописано в <body> руками (модалки, тосты), нужно убрать перед
 * снятием снапшота — иначе при возврате назад страница покажется с открытой
 * модалкой.
 */
function cleanInjectedNodes() {
  document.addEventListener("turbo:before-cache", () => {
    document.querySelectorAll("[data-turbo-temporary]").forEach((el) => el.remove());
    document.querySelectorAll("dialog[open]").forEach((el) => el.close());
    document.body.classList.remove("u-no-scroll");
  });
}

export function installTurbo() {
  handleMissingFrame();
  installLoading();
  markExternalLinks();
  cleanInjectedNodes();
}
